import { c as _c } from "react-compiler-runtime";
import { useCallback } from 'react';
import { useIsFoldersMode } from 'framework-listing-lib/internal/hooks/useUIMode';
import useCurrentFolderId from './useCurrentFolderId';
import useFolderMoveHistoryState from './useFolderMoveHistoryState';
export default function useIsMovingToAnotherFolder() {
  "use memo";

  const $ = _c(4);
  const currentFolderId = useCurrentFolderId();
  const [state] = useFolderMoveHistoryState();
  const isFoldersMode = useIsFoldersMode();
  let t0;
  if ($[0] !== currentFolderId || $[1] !== isFoldersMode || $[2] !== state) {
    t0 = objectId => isFoldersMode && currentFolderId in state && state[currentFolderId].includes(objectId);
    $[0] = currentFolderId;
    $[1] = isFoldersMode;
    $[2] = state;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}